import { SlateDto } from '@tribeplatform/slate-kit/dtos'

export const sampleHomeSidebarSlate = {
  id: 'SLHVnfduvos833',
  rootBlock: 'root',
  blocks: [
    {
      id: 'root',
      name: 'List',
      props: {
        spacing: 'none',
      },
      children: ['sidebar'],
    },
    {
      id: 'sidebar',
      name: 'List',
      props: {
        spacing: 'md',
      },
      children: ['sidebar-1', 'sidebar-2'],
    },
    {
      id: 'sidebar-1',
      name: 'AuthMemberCard',
      props: {
        memberId: '$memberId',
      },
    },
    {
      id: 'sidebar-2',
      name: 'Leaderboard',
      props: {
        memberId: '$memberId',
      },
    },
  ],
} as unknown as SlateDto
